export enum GridBlock {
  Root = '.Grid',
}

export enum GridExternalClassName {
  Cell = 'ag-cell',
}
